export var getNavigatorGeolocationOptions = function () {
    return {
        enableHighAccuracy: true,
        timeout: 60000,
        maximumAge: 0
    };
};
